import React from 'react';
import TopBar from './Overlays/TopBar';

const MaintenancePage = () => {
    const contactPhone = window.APP_CONFIG?.CONTACT_PHONE || '';

    return (
        <div className="min-h-screen bg-white">
            <TopBar />
            <div className="flex flex-col items-center px-4" style={{ paddingTop: '140px' }}>
                <img
                    src="/icons/backsoon.png"
                    alt="We'll Be Back Shortly"
                    style={{ maxWidth: '280px', width: '100%', marginBottom: '32px' }}
                />
                <p className="text-gray-600 text-center mb-8" style={{ fontSize: '22px' }}>
                    This system is down for scheduled maintenance.<br />
                    We'll be back up shortly.
                </p>
                <div className="text-center">
                    <p className="text-gray-700 font-bold mb-1" style={{ fontSize: '20px' }}>
                        Need Help?
                    </p>
                    <a
                        href={`tel:${contactPhone}`}
                        className="font-bold mb-1 block"
                        style={{ color: '#2b7bb9', fontSize: '22px' }}
                    >
                        (877) 333-9992
                    </a>
                    <p className="text-gray-500" style={{ fontSize: '18px' }}>
                        Monday &ndash; Friday, 8:00 a.m. &ndash; 7:00 p.m. ET<br />
                        Saturday 8:00 a.m. &ndash; 4:30 p.m. ET
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;
